import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { PlatformCodeMap } from "@/pages/authorization-management/components/auth-edit-drawer/constants";
type IKey = keyof typeof PlatformCodeMap;
const t = getTranslateNsT("center");

export function getPlatformTranslation(platforms: number[] | undefined) {
  if (!platforms) return [];
  return Object.keys(PlatformCodeMap)
    .filter((key) => platforms.includes(PlatformCodeMap[key as IKey]))
    .map((_key) => t(`user_auth_form_${_key}`));
}
